import { UserNameItem } from 'modules/user';
import { useSettings } from 'context/SettingsContext';
import type { UserIncomeReportRowType } from '@econtractor/types';
import { formatIncomeLocal, formatIncomePrimary } from '../model';

interface ReportUsersSummaryTableRowProps {
    user: UserIncomeReportRowType;
}

const ReportUsersSummaryTableRow = ({ user }: ReportUsersSummaryTableRowProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;
    const amount = Number(user.amount) || 0;
    const amountRate = Number(user.amountRate) || 0;

    return (
        <tr>
            <td className="name">
                <UserNameItem
                    user={{
                        userName: user.userName,
                        userEmail: user.userEmail,
                        userPicture: user.userPicture || undefined,
                    }}
                />
            </td>
            <td className="income text-end">
                <h6 className="mb-1 text-break">{formatIncomePrimary(amount, rate)}</h6>
                {!isUahMode && (
                    <p className="text-muted f-12 mb-0 my-1">{formatIncomeLocal(amountRate)}</p>
                )}
            </td>
        </tr>
    );
};

export default ReportUsersSummaryTableRow;
